import { Json, JsonEntity } from '@homeleite/arch';

export type ContactCategory = 'PHONE' | 'EMAIL' | 'CELL';

export class Contact implements JsonEntity {
  constructor(
    public detail = '',
    public descrition = '',
    public category: ContactCategory = 'PHONE'
  ) {}

  toJson() {
    return Json.to.simple(this);
  }

  static fromJson(json: any) {
    return Json.from.simple(json, Contact);
  }
}
